var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "7b00fce4e1f3be3a3e6acfe65a49fd9254e61e3c"
};